import { useSyncExternalStore } from 'react'

export type ToastType = 'success' | 'error' | 'info'
export interface ToastItem {
  id: number
  message: string
  type: ToastType
}

let toasts: ToastItem[] = []
let nextId = 1
const listeners = new Set<() => void>()

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

function emit() {
  listeners.forEach((cb) => cb())
}

export function toast(message: string, type: ToastType = 'info') {
  const id = nextId++
  toasts = [...toasts, { id, message, type }]
  emit()
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id)
    emit()
  }, 3500)
}

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(subscribe, () => toasts)
}
